import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-viewharshita-gautam',
  templateUrl: './viewharshita-gautam.component.html',
  styleUrls: ['./viewharshita-gautam.component.scss']
})
export class ViewharshitaGautamComponent implements OnInit {
  
  randNumber = Math.floor(Math.random()  * 1000000);
  id:any;
  data:any;

  constructor(private activatedRoute: ActivatedRoute, private crudservice: CrudService) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.getOne();
  }

  getOne(){
    this.crudservice.getOne(this.id).subscribe((data: any)=>{
      this.data = data;
      //console.log(this.data);
    })
  }
  
  
}
